import { useEffect, useState } from 'react';
import { useToastDispatchContext } from '/src/layouts/toast/context/toastContext';

function useNetwork() {

    const toast = useToastDispatchContext();

    const [toastData, setToastData] = useState(null)
    /*
    if(!navigator.onLine) {
        //toast.error('No connexion', 'please connect', 0);
    }*/
    const deleteTime = 250;

    const offlineDispatch = () => {

        if(toastData) {
            setTimeout(() => toast.dispatch({ type: 'deleteToast', payload : { id : toastData.id } }), deleteTime);
        }

        setTimeout(() => {
            const data = toast.error('No connexion available', "Please connect your computer to a router wifi :'( ", 5000, 0);
            setToastData(data);
         } ,deleteTime + 50);
    }

    const onlineDispatch = () => {
        if(!toastData) {
            return;
        }

        toast.dispatch({ type: 'updateToast', payload : { ...toastData, deleteTime } }) 
        setTimeout(() => toast.dispatch({ type: 'deleteToast', payload : { id : toastData.id } }), deleteTime);
        setTimeout(() => {
            var data = toast.success('Your connexion is back !', 'We are happy to see you back, have a nice time', 5000)
            setToastData(data);
         } ,deleteTime + 50);
    }

    useEffect(() => {
        
        window.addEventListener('online', onlineDispatch);
        window.addEventListener('offline', offlineDispatch);

        return () => {
            window.removeEventListener('online', onlineDispatch);
            window.removeEventListener('offline', offlineDispatch);
        }

    }, [toastData])
}

export default useNetwork;
